import axios from '@/axios'
import config from '@/constant/config'
import { getApp, getApps, initializeApp } from 'firebase/app'
import {
  getAuth,
  inMemoryPersistence,
  setPersistence,
  signInWithCustomToken,
  signOut
} from 'firebase/auth'
import { getDatabase, onValue, ref } from 'firebase/database'

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
}

let sessionTimer

export const isAdminChatRealtimeClientConfigured = () => Object.values(firebaseConfig).every(Boolean)

const getServices = () => {
  if (!isAdminChatRealtimeClientConfigured()) {
    throw new Error('CHAT_REALTIME_CLIENT_UNAVAILABLE')
  }
  const app = getApps().length ? getApp() : initializeApp(firebaseConfig)
  return {
    auth: getAuth(app),
    database: getDatabase(app)
  }
}

export const startAdminChatRealtime = async () => {
  if (!isAdminChatRealtimeClientConfigured()) {
    return false
  }
  const configResponse = await axios.get(config.api.chat.config)
  if (!configResponse.data.data.realtimeEnabled) {
    return false
  }
  const tokenResponse = await axios.post(config.api.chat.firebaseToken, undefined, {
    headers: { 'X-Chat-CSRF-Token': configResponse.data.data.csrfToken }
  })
  const { auth } = getServices()
  await setPersistence(auth, inMemoryPersistence)
  await signInWithCustomToken(auth, tokenResponse.data.data.token)
  clearInterval(sessionTimer)
  sessionTimer = setInterval(() => {
    axios.get(config.api.chat.config)
      .then(response => {
        if (!response.data.data.realtimeEnabled) {
          void stopAdminChatRealtime()
        }
      })
      .catch(() => {
        void stopAdminChatRealtime()
      })
  }, 60000)
  return true
}

export const getAdminChatRealtimeDatabase = () => getServices().database

export const subscribeToAdminChatQueue = (onMeta, onError) => onValue(
  ref(getServices().database, '/chat/conversationMeta'),
  snapshot => onMeta(Object.values(snapshot.val() || {})),
  onError
)

export const subscribeToAdminConversation = (conversationId, onMessages, onError) => onValue(
  ref(getServices().database, `/chat/messages/${conversationId}`),
  snapshot => onMessages(Object.values(snapshot.val() || {})
    .sort((left, right) => (left.createdAt || 0) - (right.createdAt || 0))),
  onError
)

export const stopAdminChatRealtime = async () => {
  clearInterval(sessionTimer)
  sessionTimer = undefined
  if (!isAdminChatRealtimeClientConfigured() || !getApps().length) {
    return
  }
  await signOut(getAuth(getApp()))
}
